// extracted by mini-css-extract-plugin
export default {"notification":"notification-bar_notification__BwuOT","check":"notification-bar_check__lWPy5"};